<template>
  <div class="AutoColdOfferCardContainer">
    <ColdOfferCard
      :interest-rate="cptdOfferInterestRate"
      :max-duration="cptdOfferDurationMax"
      :max-amount="cptdOfferMaxAmount"
      :partner="offer.partner"
      @action-forward-click="simulateColdOffer"
      @offer-conditions-click="simulateColdOffer"
      @brand-click="simulateColdOffer"
    />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { formatDateToNumericDate, localDate } from '@/helpers/date'
import { Partner } from '@/data/common'
import ColdOfferCard from '~/aasgard/components/cards/ColdOfferCard.vue'
export default {
  name: 'AutoColdOfferCardContainer',
  components: {
    ColdOfferCard,
  },
  props: {
    offer: { type: Object, required: true },
  },
  computed: {
    ...mapGetters({
      gtAutoColdOffers:
        'products/loans/auto-equity/cold-offer/gtAutoColdOffers',
    }),
    cptdIsBvOrCreditas() {
      return [Partner.CREDITAS, Partner.BV].includes(this.offer?.partner)
    },
    cptdHasCreditasAndBv() {
      return (
        !!this.gtAutoColdOffers.find((co) => co.partner === Partner.CREDITAS) &&
        !!this.gtAutoColdOffers.find((co) => co.partner === Partner.BV)
      )
    },
    cptdOfferMaxAmount() {
      return this.offer?.amount_max ?? 0
    },
    cptdOfferDurationMax() {
      return this.offer?.duration_max ?? 0
    },
    cptdOfferInterestRate() {
      return this.offer?.monthly_interest_rate ?? 0
    },
    cptdOfferExpirationDate() {
      if (!this.offer?.expiration_date_time) return ''
      try {
        return formatDateToNumericDate(
          localDate(this.offer?.expiration_date_time),
          'dd/mm/yyyy as hh:mm',
        )
      } catch (e) {
        return ''
      }
    },
  },
  methods: {
    ...mapActions({
      actSetSelectedColdOffer:
        'products/loans/auto-equity/cold-offer/actSetSelectedColdOffer',
      actSetLastLoanInteraction: 'ui/user-activity/actSetLastLoanInteraction',
    }),
    async simulateColdOffer() {
      const { partner } = this.offer
      this.actSetLastLoanInteraction('auto-equity')
      if (this.cptdIsBvOrCreditas && this.cptdHasCreditasAndBv) {
        this.$router.push({
          path: `/forms/emprestimo/auto/parceiros/simular`,
        })
      } else {
        await this.actSetSelectedColdOffer(this.offer)
        this.$router.push({
          path: `/forms/emprestimo/auto/parceiros/${partner.toLowerCase()}/simular`,
        })
      }
    },
  },
}
</script>
<style lang="scss"></style>
